import React from 'react';
import styled from 'styled-components/macro';
import { DeviceSize } from '../components/basic/DeviceSize';
import { useMessageGetter } from 'react-message-context';
import { Body2 } from '../components/common';

const DescriptionContainer = styled.div`
  margin: 20px 0 0;

  li {
    padding: 2px 0;
  }

  @media ${DeviceSize.mobileL} {
    ul {
      padding-left: 20px;
    }
  }
`;

const DescriptionHeading = styled.h3`
  font-size: 16px;
  font-weight: 400;
`;

const ServiceDescription = () => {
  const t = useMessageGetter('signin.step1');

  const getDescriptionItemList = (content: string) => {
    if (!content) return <></>;
    return (
      <ul>
        {content.split('\n').map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>
    );
  };

  return (
    <DescriptionContainer>
      <Body2>{t('newSignupInfo')}</Body2>
      <DescriptionHeading>{t('descriptionTitle')}</DescriptionHeading>
      {getDescriptionItemList(t('descriptionItems'))}
    </DescriptionContainer>
  );
};

export default ServiceDescription;
